import { useDirectusFiles, useHead } from "#imports";
import { useNuxtApp, useRoute } from "#app";
import get from "lodash-es/get";
import set from "lodash-es/set";
import { useGenerateMeta } from "./useGenerateMeta.mjs";
import { parse as parseHTML, parseTag } from "../lib/hypertag.mjs";
export const useDirectusGlobalSeo = () => {
  const { $SEOSettings } = useNuxtApp();
  const { getThumbnail } = useDirectusFiles();
  const route = useRoute();
  const lang = route.params?.lang ?? route.params?.defaultLang ?? "vi";
  if (import.meta.env.DEV) {
  }
  const generalConfig = get($SEOSettings?.general, lang, {});
  const advancedConfig = get($SEOSettings?.advanced, lang, {});
  const localSEO = get($SEOSettings?.local_seo, lang, {});
  let robots = "index, follow";
  let meta_robots = get(generalConfig, "meta_robots") || robots;
  if ("string" !== typeof meta_robots) {
    meta_robots = !meta_robots.includes("nofollow") ? [...meta_robots, "follow"] : meta_robots;
    meta_robots = meta_robots?.join(", ");
  }
  set(generalConfig, "meta_robots", meta_robots);
  const meta = [];
  const data = [
    {
      id: "description",
      value: "meta_description"
    },
    {
      id: "robots",
      value: "meta_robots"
    },
    {
      id: "og:type",
      value: "website"
    },
    {
      id: "og:image",
      value: "facebook_image"
    },
    {
      id: "og:title",
      value: "facebook_title"
    },
    {
      id: "og:description",
      value: "facebook_description"
    },
    {
      id: "twitter:card",
      value: "summary"
    },
    {
      id: "twitter:image",
      value: "twitter_image"
    },
    {
      id: "twitter:title",
      value: "twitter_title"
    },
    {
      id: "twitter:description",
      value: "twitter_description"
    },
    {
      id: "google-site-verification",
      value: "google_verification_code"
    },
    {
      id: "msvalidate.01",
      value: "bing_verification_code"
    },
    {
      id: "yandex-verification",
      value: "yandex_verification_code"
    },
    {
      id: "p:domain_verify",
      value: "pinterest_verification_code"
    },
    {
      id: "baidu-site-verification",
      value: "baidu_verification_code"
    }
  ];
  data.forEach(({ id, value = "" }) => {
    value = get(generalConfig, value);
    let content = get(generalConfig, value?.replace(/facebook_|twitter_/, "meta_"));
    content = value || content;
    if (id.includes("image") && value) {
      content = getThumbnail(value);
      meta.push(useGenerateMeta(id, content));
      return;
    }
    if (content) {
      meta.push(useGenerateMeta(id, content));
    }
  });
  const link = [];
  const style = [];
  const script = [];
  const noscript = [];
  const headerCode = get(advancedConfig, "header_code", "");
  const footerCode = get(advancedConfig, "footer_code", "");
  function generateTags(code, body = false) {
    const linkTags = parseHTML(code, ["link"], { tagKey: "tag" }).map((link2) => {
      delete link2.tag;
      return link2;
    });
    link.push(...linkTags);
    const tags = parseTag(code, ["script", "style", "noscript"]).map((tag) => {
      const type = tag.tag;
      delete tag.tag;
      tag.body = body;
      switch (type) {
        case "style":
          style.push(tag);
          break;
        case "script":
          script.push(tag);
          break;
        default:
          noscript.push(tag);
          break;
      }
    });
  }
  if (headerCode) {
    generateTags(headerCode);
  }
  if (footerCode) {
    generateTags(footerCode, true);
  }
  useHead({
    title: generalConfig?.meta_title,
    meta,
    link,
    // @ts-ignore
    style,
    script,
    noscript
  });
};
